import config from '../../../config';
import { ContentType } from '../../../content-types';
import { getDefaultContent } from '../../../utils';

import type { ClientRoute } from '../../../static-context';

interface GetRelatedBreedLinksArgs {
  allRoutes: ClientRoute[];
  buildId: string;
}

export function getRelatedBreedLinks({
  allRoutes,
  buildId,
}: GetRelatedBreedLinksArgs) {
  const numItemsToReturn = config.get('content.numRelatedBreedLinks');

  const allBreedLinks = allRoutes.filter(isBreedRoute);

  return getDefaultContent({
    items: allBreedLinks,
    numItemsToReturn,
    seed: buildId,
  });
}

function isBreedRoute(route: ClientRoute): boolean {
  const breedUrlRegex = new RegExp(`^\\/${ContentType.breed}\\/`, 'gi');
  return Boolean(breedUrlRegex.exec(route.url));
}
